<div class="container-fluid sell_dash">
  <div class="wrapper">
    <div class="row">
      <app-sidemenu></app-sidemenu>
      <section class="right">
        <app-sellheader></app-sellheader>
        <div class="right-middle row justify-content-center">
          <div class="col-md-10 col-lg-8 col-xl-11 col-10 col-sm-10 space">
            <div class="row">
              <div class="col-sm-6 left-card">
                <div class="card">
                  <div
                    class="card-img-top left-head card-header"
                    style="
                      background-image: url('../../../assets/image/PreviousTransaction.png');
                    "
                  >
                    <h4>Transaction History</h4>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-6" style="text-align: center;">
                        <p class="heading">Total Transactions</p>
                      </div>
                      <div class="col-sm-6" style="text-align: center;">
                        <h1 class="price">$432</h1>
                      </div>
                    </div>
                     <div class="kt-portlet kt-portlet--mobile dataoffering_backgroun mt-4">
                      <div class="kt-subheader kt-grid__item shadow-sm" id="kt_subheader">
                         <div class="kt-container  kt-container--fluid ">
                         <div class="kt-subheader__main">
                            <h5 class="kt-subheader__title">
                               Current Purchases
                            </h5>
                            <span class="kt-subheader__separator kt-subheader__separator--v"></span>
                            <div class="kt-subheader__group" id="kt_subheader_search">
                               <span class="kt-subheader__desc" id="kt_subheader_total">
                               6 Total </span>
                            </div>

                         </div>
                         <div class="kt-subheader__toolbar">
                            <a routerLink="/purchase" class="btn btn-label-brand">
                            Buy Now </a>
                         </div>
                         </div>
                      </div>
                       <div class="kt-portlet__body kt-portlet__body--fit shadow-sm">
                        <div class="kt-section__content">
                          <table class="table">
                          <thead class="text-primary text-center">
                            <th>SNO.</th>
                            <th>Asset Name</th>
                            <th>Asset Type</th>
                            <th>Paid</th>
                            <th>Transaction Time</th>
                          </thead>
                          <tbody class="text-center">
                            <tr class="text-data" *ngFor="let transaction of transactions | paginate: {itemsPerPage:3,currentPage: p}">
                              <td>{{transaction.sr}}</td>
                              <td>{{transaction.Asset_name}}</td>
                              <td>{{transaction.Asset_Type}}</td>
                              <td>{{transaction.Paid}}</td>
                              <td>{{transaction.Transaction_Time}}</td>
                            </tr>
                          </tbody>
                          </table>
                          <div class="mt-1 text-center kt-portlet__foot">
                           <pagination-controls (pageChange)="p = $event" class="mt-4"></pagination-controls>
                          </div>
                       </div>
                       </div>
                     </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-5 right-card">
                <div class="card">
                  <div
                    class="card-img-top right-head card-header"
                    style="
                      background-image: url('../../../assets/image/AddToken.png');
                    "
                  >
                    <p class="right-head-p">Wallet</p>
                    <div class="head">
                      <h4>Add Tokens</h4>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row body-head">
                      <div class="col-sm-6" style="text-align: center;">
                        <p class="heading">Token Balance</p>
                      </div>
                      <div class="col-sm-6" style="text-align: center;">
                        <h1 class="price">500</h1>
                      </div>
                    </div>
                    <div class="row body-token">
                      <div class="col-sm-12 input">
                        <input type="text" placeholder="Enter Token Amount(USD)" />
                      </div>
                    </div>
                    <div class="row body-amt">
                      <div class="col-sm-8" style="text-align: center;">
                        <p>Total tokens to be granted</p>
                      </div>
                      <div class="col-sm-4" style="text-align: center;">
                        <p>500</p>
                      </div>
                    </div>
                    <div class="row body-pay">
                      <div class="col-sm-12">
                        <div class="row info-btn">
                          <p class="col-lg-10 col-md-10 text-center">Total amount to be paid = 500 USD</p>
                          <a class="col-lg-2 col-md-2"><img src="../../../assets/image/info.png"></a>
                        </div>
                        <div class="row paybtn">
                          <button class="btn btn-primary" id="rzp-button1" (click)="pay()">
                            <span class="pay">Pay Now</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- begin::Sticky Toolbar -->
      <app-stickytoolbar></app-stickytoolbar>
      <!-- end::Sticky Toolbar -->
    </div>
  </div>
</div>
